export const convertFileToStringBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(`${reader.result}`);
    reader.onerror = (error) => reject(error);
  });

export function normalizeFileName(str: string, length = 15): string {
  const nameParts = str.split('.');
  const extension = nameParts.slice(-1);
  const stars = '***';
  const lengthWithoutStart = Math.max(length - stars.length, 0);
  const rest = nameParts.slice(0, nameParts.length - 1);
  const partOfName = rest.join('').substring(0, lengthWithoutStart);
  const starsPart = partOfName.length >= lengthWithoutStart ? stars : '';
  return `${partOfName}${starsPart}.${extension}`;
}
